import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">了解皮皮喵漫画背后的故事与理念</p>
        </div>
        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/50">
          <div className="flex items-center gap-3 mb-6 justify-center">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100">
              <i className="fa-solid fa-cat text-primary-500 text-xl"></i>
            </span>
            <h3 className="text-xl font-heading font-bold text-foreground-900">{aboutInfo.title}</h3>
          </div>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto text-center">
            {aboutInfo.description}
          </p>
        </div>
      </div>
    </section>
  );
}